import React from 'react';
import {
  Button,
  Form,
  FormGroup,
  Input,
  Label,
  Row,
  Col,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Table,
  FormText
} from 'reactstrap';
import StorageService from '../services/StorageService';
import axios from 'axios';
import { MdDone, MdClear, MdCreate } from 'react-icons/md';

class AssignStoreUserForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      modal: false,
      user: '',
      role: '',
      userList: [],
      roleList: [],
      compUserList: [],
      filterUserList: [],
      storeList: [],
      store: ''
    };
  }

  changeHandler = event => {
    this.setState({
      [event.target.name]: event.target.value,
    });
  };

  handleSubmit = event => {
    event.preventDefault();

    const user = StorageService.getSession('user_info');
    const url = process.env.REACT_APP_API_URL;
    const selected_org = StorageService.getSession('selected_org');
    let stores = [];
    if(this.state.store === 'All') {
        for(let i of this.state.storeList) {
            stores.push(i.store_id);
        }
    } else {
        stores.push(this.state.store);
    }

    if(stores.length < 1) {
      return;
    }
    const data = {
      session_key: user.session_key,
      StoreID: stores,
      CompanyID: selected_org.CompanyID,
      ProfileID: this.state.user,
      Role: this.state.role,
    };

    axios
      .post(url + ':3000/v1/store/addUser', data)
      .then(response => {
        const result = response.data;
        if (result.error == true) {
          this.props.closeModal(<MdClear />, result.message, 'error', false);
          return;
        }

        this.props.closeModal(
          <MdDone />,
          'User assigned successfully.',
          'success',
          false,
        );
      })
      .catch(error => {
        alert(error);
      });
  };

  getRoleList = () => {
    const user = StorageService.getSession('user_info');
    const url = process.env.REACT_APP_API_URL;

    const data = {
      session_key: user.session_key,
    };

    axios
      .post(url + ':3000/v1/user/roles', data)
      .then(response => {
        const result = response.data;

        if (result.error == true && result.message != 'Success') {
          alert(result.message);
          return;
        }
        this.setState({ roleList: result.data });
      })
      .catch(error => {
        alert(error);
      });
  };

  getStoreList = () => {
    const url = process.env.REACT_APP_UNITY_API2_URL;
    const selected_org = StorageService.getSession('selected_org');

    const data = {
      session_key: 'MEmnAwcpRdVhAjWqqswddeRxTBrMsPzdmNvwXRyr',
      company_id: selected_org.CompanyID,
    };

    axios
      .post(url + ':3001/v1/store', data)
      .then(response => {
        const result = response.data;

        if (result.error == true && result.message != 'Success') {
          alert(result.message);
          return;
        }

        if(result.data.length > 0) {
            this.setState({ storeList: result.data, store: this.props.data.store });
        }
        
      })
      .catch(error => {
        alert(error);
      });
  };

  filterUserList = () => {
    let allUser = this.state.userList;
    let compUser = this.state.compUserList;

    let r = allUser.filter(function (a) {
      return !compUser.some(function (b) {
        return a.ProfileID === b.ProfileID; // assumes unique id
      });
    });

    this.setState({
      filterUserList: r,
    });
  };

  getStoreUser = () => {

    const url = process.env.REACT_APP_API_URL;
    const user = StorageService.getSession('user_info');
    const data = {
      session_key: user.session_key,
      StoreID: this.props.data.store,
    };

    axios
      .post(url + ':3000/v1/store/getUser', data)
      .then(response => {
        const result = response.data;

        if (result.error == true && result.message != 'Success') {
          alert(result.message);
          return;
        }

        this.setState({ compUserList: result.data });
        setTimeout(() => {
            this.filterUserList();
            }, 500);

      })
      .catch(error => {
        alert(error);
      });
  };

  getCompanyUser = () => {
    const user = StorageService.getSession('user_info');
    const url = process.env.REACT_APP_API_URL;
    const selected_org = StorageService.getSession('selected_org');
    const data = {
      session_key: user.session_key,
      CompanyID: selected_org.CompanyID,
    };

    axios
      .post(url + ':3000/v1/company/getUser', data)
      .then(response => {
        const result = response.data;

        if (result.error == true && result.message != 'Success') {
          alert(result.message);
          return;
        }
        this.setState({ userList: result.data });
      })
      .catch(error => {
        alert(error);
      });
  };

  componentDidMount() {
    this.getCompanyUser();
    this.getStoreUser();
    this.getRoleList();
    this.getStoreList();
  }

  render() {
    const user = StorageService.getSession('user_info');
    return (
      <Form onSubmit={this.handleSubmit} className="AuthForm">
        <ModalHeader toggle={this.props.onToggleModal()}>
          Assign Store User
        </ModalHeader>
        <ModalBody>
          <Row>
            <Col md={12}>
            <FormGroup>
                <Label>Store</Label>
                <Input
                type="select"
                name="store"
                value={this.state.store}
                onChange={this.changeHandler}
                required
                >
                  {this.state.storeList.length > 0 && <option value='All'>All Stores</option>}
                
                {this.state.storeList.length > 0 &&
                    this.state.storeList.map((item, index) => {
                    return (
                        <option key={index} value={item.store_id}>
                        {item.name}
                        </option>
                    );
                    })}
                </Input>
                <FormText color="muted">
            Select 'All Stores' if you want to assign selected user to all stores.
          </FormText>
            </FormGroup>
              <FormGroup>
                <Label for="user">User</Label>
                <Input
                  type="select"
                  name="user"
                  value={this.state.user}
                  onChange={this.changeHandler}
                  required
                >
                  <option value=""></option>
                  {this.state.filterUserList.length > 0 &&
                    this.state.filterUserList.map((item, index) => {
                      return (
                        <option key={index} value={item.ProfileID}>
                          {item.Email} |{' '}
                          {item.Name === null || item.Name === ''
                            ? 'Nil'
                            : item.Name}
                        </option>
                      );
                    })}
                </Input>
              </FormGroup>
              <FormGroup>
                <Label for="role">Role</Label>
                <Input
                  type="select"
                  name="role"
                  value={this.state.role}
                  onChange={this.changeHandler}
                  required
                >
                  <option value=""></option>
                  {this.state.roleList.length > 0 &&
                    this.state.roleList.map((item, index) => {
                      return (
                        <option key={index} value={item.role}>
                          {item.role}
                        </option>
                      );
                    })}
                </Input>
              </FormGroup>
            </Col>
          </Row>
        </ModalBody>
        <ModalFooter>
          <Button
            className="theme-button theme-button-secondary"
            onClick={this.props.onToggleModal()}
          >
            Close
          </Button>
          <Button className="theme-button theme-button-primary" type="submit">
            Save
          </Button>{' '}
        </ModalFooter>
      </Form>
    );
  }
}

export default AssignStoreUserForm;
